import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`flex justify-center items-center rounded-full ${_ctx.color} text-white p-4 ${_ctx.buildSize(
      _ctx.size
    )}`)
  }, _toDisplayString(_ctx.getInitials(_ctx.name)), 3))
}